// InviteUserToolbarAndModals.tsx

import React from "react";
import InviteUserTableTopToolbar from "./toolbar/InviteUserTableTopToolbar";
import { SendInviteModal } from "./modals/SendInviteModal";
import { AssignLicenseModal } from "./modals/AssignLIcenseModal";
import { BulkImportModal } from "./modals/BulkImportModal";
import { AddRoleModal } from "./modals/AddRoleModal";
import { useRunValidation } from "../../../../tanstackQuery/queries/superAdmin/session";
import { useKeycloak } from "@react-keycloak/web";
import { CreateSessionData } from "./types";
import { toast } from "sonner";
import { StartDateModal } from "./modals/StarteDateModal";

const InviteUserToolbarAndModals = ({
  activeModal,
  setActiveModal,
  inviteList,
  setInviteList,
  selectedInviteUserData,
  cohortTeamList,
  invoicesData,
  showInviteTable,
  setShowInviteTable,
  setSelectedRowData,
  addNewInviteRow,
  selectedRowData,
  userValidationData,
  setUserValidationData
}) => {
  const { keycloak } = useKeycloak();

  const {
    mutateAsync: runValidation,
    isPending: isValidationPending,
    isSuccess: isValidationSuccess,
  } = useRunValidation(
    { accessToken: keycloak?.token },
  );
  const handleRunValidation = async () => {
    if (!inviteList.data) return;

    const { created, modified, createdF, modifiedF, ...filteredData } = selectedRowData;
    const payload: CreateSessionData = {
      ...filteredData,
      status: "editing",
      payload: JSON.stringify({
        ...inviteList,
      }),
    };

    try {
      const response = await runValidation(payload);
      if (response) {
        setUserValidationData(response)
        toast.success("Validation successfully completed!");
      }
     } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to send invitation."
      );
     }
  };



  return (
    <>
      <InviteUserTableTopToolbar
        showInviteTable={showInviteTable}
        setShowInviteTable={setShowInviteTable}
        setSelectedRowData={setSelectedRowData}
        setActiveModal={setActiveModal}
        addNewInviteRow={addNewInviteRow}
        inviteList={inviteList}
        userValidationData={userValidationData}
        runValidation={handleRunValidation}
        isValidationPending={isValidationPending}
      />

      {activeModal === "inviteUser" && (
        <SendInviteModal 
          open 
          handleClose={() => setActiveModal(null)} 
          inviteList={inviteList}
          selectedRowData={selectedRowData}
        />
      )}

      {activeModal === "assignLicense" && (
        <AssignLicenseModal
          open
          handleClose={() => setActiveModal(null)}
          invoicesData={invoicesData}
          setInviteList={setInviteList}
          inviteList={inviteList}
          selectedInviteUserData={selectedInviteUserData}
        />
      )}

      {activeModal === "bulkImport" && (
        <BulkImportModal
          open
          handleClose={() => setActiveModal(null)}
          setInviteList={setInviteList}
        />
      )}

      {activeModal === "addRole" && (
        <AddRoleModal
          open
          handleClose={() => setActiveModal(null)}
          inviteList={inviteList}
          setInviteList={setInviteList}
          selectedInviteUserData={selectedInviteUserData}
          cohortTeamList={cohortTeamList}
        />
      )}

      {activeModal === "startDate" && (
        <StartDateModal
          open
          handleClose={() => setActiveModal(null)}
          setInviteList={setInviteList}
        />
      )}
    </>
  );
};

export default InviteUserToolbarAndModals;
